/*
 * @Author: gaoqiaoning gao201203
 * @Date: 2024-02-05 15:53:09
 * @LastEditors: gaoqiaoning gao201203
 * @LastEditTime: 2024-02-05 15:53:09
 * @FilePath: \yayi-chat-front\common\i18n\common\en-US.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
    header: {
        application: 'Experience application',
        // feedback: 'Community Feedback',
        feedback: 'Community',
        // center: 'Help Center',
        center: 'Help',
        login: 'login',
        register: 'register',
        logout: 'Logout',
        defaultName: 'Yayi',
        personal: 'Profile',
        manage: 'System Setting',
        logOutTitle: 'Tips',
        logOutMessage: 'This operation will log out. Do you want to continue?',
        logOutConfirm: 'Confirm',
        logOutCancel: 'Cancel',
    },
    router: {
        home: 'Home',
        // chat: 'Intelligent Q&A',
        aisearch:"AI搜索",
        chat: 'Chat',
        center:'AgentCenter',
        // file: 'Knowledge Base',
        file: 'File',
        // uie: 'Knowledge extraction',
        uie: 'Extraction',
        publick:'conversations with YAYI{name}',
        globalTitle: 'YAYI',
        backendManage: 'Backend Manage',
        YAYIFile: 'YAYIFile',
        knowledgeManage: 'Knowledge Base Manage',
        thumbsManage: 'Thumbs up/down Management',
        QAndA: 'Q&A Record',
        profile: 'Profile',
        accountOverview: 'Overview',
        rechargeManagement: 'Recharge Management',
        accountRecharge: 'Account Recharge',
        rechargeDetails: 'Recharge Details',
        expenseDetails: 'Expense Details',
        callStatistics: 'Call Statistics',
        accountSettings: 'Profile',
        login: 'Login',
        trialApplication: 'Trial Application',
        ServiceAgreement: 'Service Agreement',
        privacyPolicy: 'Privacy Policy',
        uieDetail: 'Uie Detail',
        share:"Share",

    },
    fontSize: {
        small: 'Small',
        default: 'Middle',
        large: 'Large',
        text:"Text Size"
    },
    model: {
        title: 'early access',
        describe: 'The effect of YAYI 2.0 has been fully upgraded, and the AI ​​work assistant can better improve your work efficiency.',
        describe2: 'Limited to 100 experiences per day',
        unit: 'times',
        intelligenTitle: 'Advanced web search',
        test:'Beta',
        // intelligenDescribe: 'YAYI 2.5 has preset all plugin services (CV understanding, long text, document parsing, weather, calculator, networking, Wen Hai), and the model will automatically retrieve plugins and answer questions based on problem judgment.'
        intelligenDescribe: 'Analyze problems in depth, break down complex problems into interrelated sub-problems, and ensure that each problem has a clear direction. Through deep search, collect authoritative information source data, rapid analysis and summary of intelligent assistant.'
        
    },
    tips:{
        title:'YAYI-2024/6/13version',
        add:'Key updates',
        tips1:'YAYI 2.5- Advanced Networking Q&A',
        info1:'The complex problems raised by users will be broken down into multiple interrelated sub-problems, and authoritative information source data will be collected through in-depth search, and rapid analysis and summary.',
        tips2:'Agent - Application configuration upgrade',
        info2:'Add smart search experts, and based on user habits, support all, hot, my switch agent.',
        tips3:'Instruction application - Easy and efficient reference',
        info3:'Optimized instruction usage path, placed above the input box; Users only need to enter "/+ keyword" to quickly search for instructions.',
        tips4:'Long document question answering',
        info4:'Support to add multiple documents, multiple urls, support multi-round dialogue based on documents.',
        btn:"Immediate experience",
        modelTipsTitle:'YAYI 2.5 is online now',
        tip1:'1.Click the upper part to switch functions',
        tip2:'2.YAYI 2.5 supports advanced Internet search',
        infoMessage:'This model does not support URL resolution, please use XiaoYa',
        infoMessage1:'The number of urls has reached online',
        infoMessage2:'This label is not supported',
        ignore:"Ignore this version"

    }
}